import * as React from 'react';

import { ApplicationState, ConnectedReduxProps } from '../../store';
import { CalculationUsageTC, ReportTypeTC } from '../../business/models/typecode.enums';
import { fetchDaccaCalculations, openDacca } from '../../store/details/dacca/actions';

import { DaccaCalculation } from '../../store/details/dacca/types';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { Company } from '../../store/shared/model';

const styles = {
  daccaButton: {
    display: 'flex',
    justifyContent: 'center',
    padding: '5px',
    marginLeft: 'auto',
    width: '100px',
    cursor: 'pointer'
  }
};

interface DaccaButtonProps {
  readonly reportType: string;
}

interface PropsFromState {
  readonly daccaCalculations: DaccaCalculation[];
  readonly daccaBaseURL: string;
  readonly parentPartyDibCode: string;
  readonly caseCode: string;
}

interface PropsFromDispatch {
  readonly openDacca: typeof openDacca;
  readonly getSubClaimOverview: typeof fetchDaccaCalculations;
}

class DaccaButton extends React.Component<DaccaButtonProps & PropsFromDispatch & PropsFromState & ConnectedReduxProps> {

  componentDidMount() {
    this.props.getSubClaimOverview(this.props.caseCode);
  }

  render() {

    const isBelfiusParentCompany = this.props.parentPartyDibCode === Company.Belfius;

    const calculations = this.props.reportType === ReportTypeTC.Rim
      ? this.props.daccaCalculations.filter(p => p.calculationUsageTC === CalculationUsageTC.Fin || p.calculationUsageTC === CalculationUsageTC.Diy)
      : this.props.daccaCalculations.filter(p => p.calculationUsageTC === CalculationUsageTC.Rik);

    const daccaButtonImagePath = calculations.length > 0
      ? require('../../assets/images/dacca_with_calculation_85x85.png')
      : require('../../assets/images/dacca_85x85.png');

    const consultDaccaUrl = calculations.length === 1
      ? `${this.props.daccaBaseURL}/Claim/CalculationItems?id=${calculations[0].calculationVersionID}`
      : `${this.props.daccaBaseURL}/Claim/ClaimSearch?claimNumber=${this.props.caseCode}&searchMode=All`;


    return (
       (isBelfiusParentCompany ?
         <div style={styles.daccaButton}
          onClick={() => {
            this.props.openDacca();
          }} >
          <a target='_blank' href={consultDaccaUrl} rel="noreferrer">
            <img alt="" src={daccaButtonImagePath} />
          </a>
        </div>  : '')
    );
  }
}

const mapStateToProps = ({ details: { detailsDacca }, shared, caseState: { selectedCase } }: ApplicationState) => ({
  daccaCalculations: detailsDacca.daccaCalculations,
  daccaBaseURL: detailsDacca.daccaBaseURL,
  parentPartyDibCode: shared.parentPartyDibCode,
  caseCode: selectedCase.caseCode,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getSubClaimOverview: (caseCode: string) => dispatch(fetchDaccaCalculations(caseCode)),
  openDacca: () => dispatch(openDacca())
});

export default connect(mapStateToProps, mapDispatchToProps)(DaccaButton);
